import { setTags } from '@sentry/browser';
import type { AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import getTrackingHeaders from './utils/getTrackingHeaders';

interface RequestConfig extends AxiosRequestConfig {
  headers: AxiosRequestHeaders;
}

const requestHeaders = (request: AxiosRequestConfig): RequestConfig => {
  const trackingHeaders = getTrackingHeaders();

  request.headers = {
    ...request.headers,
    ...trackingHeaders,
  };

  setTags(trackingHeaders);

  return request as RequestConfig;
};

export default requestHeaders;
